import { FONT, RADIUS } from "@/styles/common";
import { Box, Center } from "@chakra-ui/react";
import styled from "@emotion/styled";

interface CustomTextProps {
    isCheckIn: boolean;
    isCheckOut: boolean;
    isBetween: boolean;
    isMaxValid?: boolean;
    weekDayNum?: number;
    isRealDate?: number | boolean;
}

export const CustomBox = styled(Box)<CustomTextProps>`
    width: 48px;
    height: 48px;
    position: relative;
    box-sizing: border-box;
    cursor: ${({ isRealDate }) => (isRealDate ? "pointer" : "default")};
    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        width: 36px;
        height: 36px;
    }

    &.low_than_today div {
        color: ${({ theme }) => theme.COLOR.gray[300]};
    }

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: ${({ isCheckIn }) => (isCheckIn ? "50%" : "0")};
        width: ${({ isCheckIn, isCheckOut }) => (isCheckIn || isCheckOut ? "50%" : "0")};
        height: 100%;
        background-color: ${({ theme }) => theme.COLOR.pink[100]};
        z-index: 1;
    }
`;

export const CustomText = styled(Center)<CustomTextProps>`
    position: absolute;
    ${FONT("pretendard", 14, 500)};
    z-index: 2;
    color: ${({ isCheckIn, isCheckOut, theme, isMaxValid, weekDayNum }) => {
        if (isCheckIn || isCheckOut) return theme.COLOR.white;
        if (isMaxValid) return theme.COLOR.gray[300];
        if (weekDayNum === 0) return theme.COLOR.pink[200];
        if (weekDayNum === 6) return theme.COLOR.blue[300];

        return theme.COLOR.black;
    }};

    background-color: ${({ isCheckIn, isCheckOut, isBetween, theme }) => {
        if (isCheckIn) return theme.COLOR.pink[200];
        if (isCheckOut) return theme.COLOR.pink[200];
        if (isBetween) return theme.COLOR.pink[100];

        return theme.COLOR.white;
    }};

    ${({ isBetween }) => (isBetween ? RADIUS(0) : RADIUS(50))};

    &:hover {
        border: 1px solid ${({ theme, isRealDate }) => (isRealDate ? theme.COLOR.pink[200] : "none")};
        ${RADIUS(50)};
    }
`;
